import { FC } from 'react';
import type { ButtonProps as MUIButtonProps } from '@mui/material/Button';
import { IconButtonProps as MUIIconButtonProps } from '@mui/material/IconButton';
import { StyledButton, StyledButtonProps, StyledIconButton, type StyledIconButtonProps } from './styles';

export type ButtonProps = MUIButtonProps & StyledButtonProps

export const Button: FC<ButtonProps> = props => {
  const { variantStyle = 'primary', children, ...rest } = props;
  return <StyledButton
    variantStyle={variantStyle}
    disableFocusRipple
    {...rest}
  >
    {children}
  </StyledButton>;
};

export type IconButtonProps = MUIIconButtonProps & {
  active?: boolean;
}

export const IconButton = (props: IconButtonProps & StyledIconButtonProps) => {
  const { variantStyle = 'primary', size = 'medium', ...rest } = props;
  return <StyledIconButton variantStyle={variantStyle} size={size} disableRipple {...rest} />;
};
